var render = function render(_c,_vm){return _c('label',_vm._b({staticClass:"inline-block text-sm font-medium text-gray-700"},'label',_vm.data.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }